import React from "react";
import './addons-quota-counter.scss'
import {AddonStore} from "../../../../stores/addons-store-list";
import FontBody2 from "../../../../../../../components/fonts/font-body2/font-body2";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../../../components/fonts/font-props";
import subscriptionPlansStore from "../../../../../../subscription-plans/stores/subscription-plans-store";

const AddonQuotaCounter: React.FC<{ addon: AddonStore, addonName: string | undefined }> = ({addon, addonName}) => {

    if (!addon.isQuotaBased()) {
        return null;
    }

    const quotaFromAddon = subscriptionPlansStore.userPlan?.getQuotaFromAddon(addon.getQuotaBasedFeatureId()) ?? 0;
    const quotaFromPlan = subscriptionPlansStore.userPlan?.getQuotaFromPlan(addon.getQuotaBasedFeatureId());

    return (
        <div className="addons-quota-counter">
            {quotaFromAddon > 0 &&
                <div>
                    <FontBody2 variant={FONT_VARIANT.BOLD}>
                        { quotaFromAddon }
                    </FontBody2>&nbsp;
                    <FontBody2>
                        {addonName} as add-on
                    </FontBody2>
                </div>
            }
            {quotaFromPlan &&
                <div>
                    <FontBody2 color={FONT_COLOR.ACCENT1} variant={FONT_VARIANT.BOLD}>
                        { quotaFromPlan }
                    </FontBody2>&nbsp;
                    <FontBody2>
                        {addonName} included in plan
                    </FontBody2>
                </div>
            }
        </div>
    )
};

export default AddonQuotaCounter;